import SidebarMenuContainer from './SidebarMenuContainer';

export default SidebarMenuContainer;



// WEBPACK FOOTER //
// ./src/components/pages/User/Sidebar/SidebarMenu/index.js